// extracted by mini-css-extract-plugin
export var animationContainer = "_n1-0";
export var footer = "_n1-1";
export var gray = "_n1-2";
export var lineItem = "_n1-3";
export var lineItemImage = "_n1-4";
export var lineItemInfo = "_n1-5";
export var lineItemText = "_n1-6";
export var lineItems = "_n1-7";
export var modalContent = "_n1-8";
export var options = "_n1-9";
export var orderName = "_n1-a";
export var refundAmount = "_n1-b";